import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Sparkle } from '../components/Sparkle';
export function PageEnConstruction() {
  const {
    pathname
  } = useLocation();
  return <main className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-start justify-center px-6 py-24" data-id="element-190" data-mp="2o0akx3i7edyh">
      <Sparkle className="h-14 w-14" color="#E76E31" data-id="element-191" data-mp="2sy2e00ul4649" />
      <h1 className="mt-6 font-display text-3xl font-bold text-nuit sm:text-4xl" data-id="element-192" data-mp="2eaheegwx4p13">
        Cette page garde sa version actuelle
      </h1>
      <p className="mt-4 text-nuit/70" data-id="element-193" data-mp="2j3air3oh5vcn">
        La refonte porte pour l’instant sur la page d’accueil. Le contenu de{' '}
        <span className="font-semibold text-nuit" data-id="element-194" data-mp="258hrx934wsqr">{pathname}</span> reste inchangé dans
        l’architecture du site.
      </p>
      <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-nuit px-6 py-3 font-semibold text-creme transition-colors duration-150 ease-out hover:bg-braise" data-id="element-195" data-mp="1vblhuyxl7yk3">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-196" data-mp="39knqknlvh4nv" />
        Retour à l’accueil
      </Link>
    </main>;
}